module.exports = __webpack_public_path__ + "img/icon-file-export.8fff9df4.svg";